module.exports = __webpack_public_path__ + "static/media/summitcounty.894c9028.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/assets/summitcounty.png
// module id = 540
// module chunks = 0